export default __webpack_public_path__ + "static/media/wednesday.7182e6c9.png";